import {linkify} from '@wandb/weave/common/util/links';
import React from 'react';

import {type Property} from '../../utilTypes';
import {getConstraintText, getDisplayName} from './util';

type PropertyHeaderProps = {
  property: Property;
  descriptionOverride?: React.ReactNode;
  action?: React.ReactNode;
};

export default function PropertyHeader({
  property,
  descriptionOverride,
  action,
}: PropertyHeaderProps) {
  const defaultDescription = (
    <>
      {linkify(property.description ?? '', {
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'font-semibold text-teal-600 hover:text-teal-500',
      })}
      {getConstraintText(property)}
    </>
  );

  return (
    <>
      <div className="flex items-center">
        <div className="text-base font-semibold leading-6 text-wb-text-primary">
          {getDisplayName(property)}
          {/* todo(sweeps-launch-team): Handle required properties ... technically all properties are optional
        !property.required && (
          <span className="ml-4 text-sm font-normal text-moon-500 dark:text-wb-text-tertiary">
            (optional)
          </span>
        )} */}
        </div>
        {action && (
          <>
            <div style={{flex: 1}} />
            <div className="flex-none">{action}</div>
          </>
        )}
      </div>
      <div className="mt-4 mb-4 text-sm font-normal leading-6 text-moon-500 dark:text-wb-text-tertiary">
        {descriptionOverride ?? defaultDescription}
      </div>
    </>
  );
}
